import { memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowChip, GlowChipProps, GlowIcon, GlowIconProps } from '../../atoms';

export type GlowIconWithChipProps = GlowIconProps &
    GlowChipProps & {
        iconClassName?: string;
        iconAlt?: string;
        chipAriaLabel?: string;
        chipClassName?: string;
    };

export const GlowIconWithChip: ComponentMemo<GlowIconWithChipProps> = memo(
    ({ Icon, type = 'large', fill, height, width, chipAriaLabel, chipClassName, iconClassName, iconAlt, ...props }) => {
        const chipPositionClass = `-top-0.375 ${props.hasDigit ? '-right-0.625' : '-right-0.375'}`;

        return (
            <div className={'relative'} data-testid={'iconChipId'}>
                <div className={clsx('absolute cursor-pointer', chipPositionClass)}>
                    <GlowChip ariaLabel={chipAriaLabel} className={chipClassName} {...props} />
                </div>
                <GlowIcon
                    Icon={Icon}
                    type={type}
                    fill={fill}
                    height={height}
                    width={width}
                    className={iconClassName}
                    alt={iconAlt}
                />
            </div>
        );
    },
);

GlowIconWithChip.displayName = 'GlowIconWithChip';
